import { render, staticRenderFns } from "./CompanyReregistration.vue?vue&type=template&id=9ee0dcce&scoped=true&"
import script from "./CompanyReregistration.vue?vue&type=script&lang=js&"
export * from "./CompanyReregistration.vue?vue&type=script&lang=js&"
import style0 from "./CompanyReregistration.vue?vue&type=style&index=0&id=9ee0dcce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee0dcce",
  null
  
)

export default component.exports